// Benchmark di mercato (call center / hospitality 2025) e semaforo colori:
// rosso = peggio della media, giallo = vicino (±5%), verde = meglio della media
export const MARKET = {
  answer_rate_pct: { value: 92.5, lowerIsBetter: false },
  wait_avg_seconds: { value: 28, lowerIsBetter: true },
  email_median_first_reply_hours: { value: 5.4, lowerIsBetter: true },
  email_within_24h_pct: { value: 90, lowerIsBetter: false },
  voicemail_recalled_4h_pct: { value: 80, lowerIsBetter: false },
  abandon_rate_pct: { value: 8, lowerIsBetter: true },
};

export const marketClass = (value, key, tolerance = 0.05) => {
  const m = MARKET[key];
  if (value == null || !m) return 'text-slate-800';
  const diff = (value - m.value) / m.value;
  if (Math.abs(diff) <= tolerance) return 'text-amber-500';
  const better = m.lowerIsBetter ? diff < 0 : diff > 0;
  return better ? 'text-emerald-600' : 'text-rose-600';
};
